import { useLanguage } from "../i18n";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [t("marq.1"), t("marq.2"), t("marq.3"), t("marq.4"), "TOKYO", "ROMA", "PARIS", "BANGKOK", "NEW YORK", "ISTANBUL"];
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="bg-[#E6F7F5] text-slate-700 py-5 overflow-hidden marquee-mask">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`mx-8 text-2xl sm:text-3xl ${i % 2 === 0 ? "font-serif-e italic" : "font-mono-t uppercase tracking-[0.2em] text-base sm:text-lg pt-1"}`}>
              {item}
            </span>
            <span className="text-[var(--accent-terracotta)] text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
